// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"271":"bonos-regalo","669":"ok","757":"ko","779":"error"}[chunkId] + "." + {"271":"f13ec572","669":"031c03de","757":"22985b7c","779":"5e58c0a2"}[chunkId] + ".css";
};